import { IcontestDataResponse, IcontestUser } from 'app/features/contest/models/contest-api.models';
import {
  IUserInfo,
  TrackInfo,
  UserTemplate,
} from 'app/features/contest/models/contest-user-info.models';

export const DEFAULT_CONTEST_TEMPLATE: UserTemplate = {
  id: 1,
  template: 'default',
};

export const DEFAULT_CONTEST_TRACK_INFO: TrackInfo = {
  country_code: 'FR',
  country_name: 'France',
  distance: 30000,
  elevationAscent: 300,
  track_duration: 3600,
  track_length: 30000,
  track_name: 'Contest track',
  track_positive_slope: 300,
  video_url: 'video.jpg',
};

export const DEFAULT_CONTEST_USER_INFO: IUserInfo = {
  template: DEFAULT_CONTEST_TEMPLATE,
  track_infos: DEFAULT_CONTEST_TRACK_INFO,
  unlocked_content: [],
  user_infos: {
    activity_sessions_count: 10,
    age: 32,
    avatar_url: 'avatar.jpg',
    birthdate: '1992-01-01',
    country: {
      code: 'FR',
      id: 1,
      intermediate_region_name: '',
      name: 'France',
      region_name: 'Europe',
      sub_region_name: 'Western Europe',
    },
    description: null,
    followers_count: 0,
    full_name: 'Contest User',
    gender: 'male',
    id: 1,
    is_contributor: false,
    is_followed: false,
    username: 'contest-user',
  },
};

export function createContestUser(overrides: Partial<IcontestUser> = {}): IcontestUser {
  const activityId: number = overrides.activity_id ?? 0;

  return {
    activity_id: activityId,
    age: '32',
    chrono: 1000 + activityId,
    completion_percentage: 50,
    email: `rider-${activityId}@example.com`,
    first_name: `First${activityId}`,
    gender: activityId % 2 === 0 ? 'male' : 'female',
    last_name: `Last${activityId}`,
    ppr: 500 - activityId,
    ranking: 1,
    start_date: 1700000000 + activityId,
    wpk: 2.5,
    ...overrides,
  };
}

export function createContestUsers(startActivityId: number, count: number): IcontestUser[] {
  return Array.from({ length: count }, (_: unknown, index: number) =>
    createContestUser({ activity_id: startActivityId + index })
  );
}

export function createContestResponse(
  participants: IcontestUser[],
  overrides: Partial<IcontestDataResponse> = {}
): IcontestDataResponse {
  const perPage: number = participants.length || 1;

  return {
    data: participants,
    links: {
      first: null,
      last: null,
      next: null,
      prev: null,
    },
    meta: {
      current_page: 1,
      from: participants.length > 0 ? 1 : null,
      last_page: 1,
      links: [
        { active: false, label: '&laquo; Previous', page: null, url: null },
        { active: true, label: '1', page: 1, url: null },
        { active: false, label: 'Next &raquo;', page: null, url: null },
      ],
      path: '',
      per_page: perPage,
      to: participants.length || null,
      total: participants.length,
    },
    unlocked_content: [],
    ...overrides,
  };
}
